import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"


export const getCreditProfilesByUser = createAsyncThunk('creditReports/getCreditProfilesByUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/profiles/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const pullCreditProfiles = createAsyncThunk('creditReports/pullCreditProfiles',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/credit-reports/profiles/users/${userId}/pull`)
      return response.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getCreditProfilesWithCooldown = createAsyncThunk('creditReports/getCreditProfilesWithCooldown',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/profiles/users/${userId}`, { params: { autoPull: 'cooldown' } })
      return response.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getSavedDebtsByUser = createAsyncThunk('creditReports/getSavedDebtsByUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/debts/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const calculatePaymentSchedule = createAsyncThunk('creditReports/calculatePaymentSchedule',
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/credit-reports/calculate-schedule`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)
export const savePaymentSchedule = createAsyncThunk('creditReports/savePaymentSchedule',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/credit-reports/users/${userId}`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const getDebtsByUser = createAsyncThunk('debts/getDebtsByUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/debts/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const getPaymentScheduleByUser = createAsyncThunk('debts/getPaymentScheduleByUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/payments/schedule/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const getPaymentScheduleStatisticsByUser = createAsyncThunk('debts/getPaymentScheduleStatisticsByUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/payments/schedule/statistics/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)


export const createSummonsFeePayment = createAsyncThunk('creditReports/createSummonsFeePayment',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/payments/summons/users/${userId}`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const saveDebtByUserId = createAsyncThunk('creditReports/saveDebtByUserId',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/debts/users/${userId}`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const saveCreditProfile = createAsyncThunk('creditReports/saveCreditProfile',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/credit-profiles/users/${userId}`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const getDebtsDropDown = createAsyncThunk('documents/getDebtsDropdown',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/debts/users/${userId}/dropdown`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get docs'
      return rejectWithValue(errorMessage)
    }
  })

export const addCreditReport = createAsyncThunk('creditReports/addCreditReport',
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/credit-reports/users/${userId}/saved`, data)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get docs'
      return rejectWithValue(errorMessage)
    }
  })

export const getLatestCreditReportByUserId = createAsyncThunk('creditReports/getLatestCreditReportByUserId',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/custUsers/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error?.errors?.[0]?.message || 'Failed to fetch credit report')
    }
  }
)

export const getCreditReportsByUserId = createAsyncThunk('creditReports/getCreditReportsByUserId',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/users/${userId}/history`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error?.errors?.[0]?.message || 'Failed to fetch credit report history')
    }
  }
)

export const getCreditReportsTypes = createAsyncThunk('creditReports/getCreditReportsTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/types`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const getCreditReportsStatuses = createAsyncThunk('creditReports/getCreditReportsStatuses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/statuses`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error.errors[0].message || 'Failed to fetch contacts')
    }
  }
)

export const deleteDebtByDebtId = createAsyncThunk(
  'creditReports/deleteDebtByDebtId',
  async ({ debtId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.delete(`/debts/${debtId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to delete debt'
      )
    }
  }
)

export const updateDebtByUserIdAndDebtId = createAsyncThunk(
  'creditReports/updateDebtByUserIdAndDebtId',
  async ({ userId, debtId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/debts/users/${userId}/debts/${debtId}`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to update debt'
      )
    }
  }
)

export const changeVerifiedAccountNumberDebts = createAsyncThunk(
  'creditReports/changeVerifiedAccountNumberDebts',
  async ({ creditProfileId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/debts/${creditProfileId}/verified`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to update debt'
      )
    }
  }
)

export const changeAccountStatusDebts = createAsyncThunk(
  'creditReports/changeAccountStatusDebts',
  async ({ creditProfileId, data }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/debts/${creditProfileId}/account-status`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to update account status'
      )
    }
  }
)

export const getDebtWorkStatus = createAsyncThunk(
  'creditReports/getDebtWorkStatus',
  async ({ userId, debtId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/debts/users/${userId}/debts/${debtId}/work-status`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const addDebtWorkStatus = createAsyncThunk(
  'creditReports/addDebtWorkStatus',
  async ({ userId, debtId, status, comment }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/debts/users/${userId}/debts/${debtId}/work-status`, { status, comment })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getCreditReportPdf = createAsyncThunk(
  'creditReports/getCreditReportPdf',
  async ({ reportId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(
        `/credit-reports/${reportId}/pdf`,
        { responseType: 'blob' }
      )
      // Validate content type before creating blob URL
      const contentType = response.headers?.['content-type'] || ''
      if (!contentType.includes('application/pdf')) {
        return rejectWithValue('Server returned non-PDF response')
      }
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const blobUrl = window.URL.createObjectURL(blob)
      return { blobUrl, reportId }
    } catch (error) {
      let message = 'Failed to load PDF'
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text()
          const parsed = JSON.parse(text)
          message = parsed?.error?.errors?.[0]?.message || message
        } catch {
          // Blob wasn't JSON, use default message
        }
      }
      return rejectWithValue(message)
    }
  }
)

export const refetchCreditReport = createAsyncThunk(
  'creditReports/refetchCreditReport',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/users/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to re-fetch credit report'
      )
    }
  }
)

export const getHouseholdCoverage = createAsyncThunk(
  'creditReports/getHouseholdCoverage',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/users/${userId}/household-coverage`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getLastCreditPull = createAsyncThunk(
  'creditReports/getLastCreditPull',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/users/${userId}/last-pull`)
      return response.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getMergedCreditProfiles = createAsyncThunk('creditReports/getMerged', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/credit-reports/profiles/users/${userId}/merged`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
